import React, { useState } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { IconButton } from "@material-ui/core";
import logo from "../../../../assets/BRCGSDirectoryLogo.png";
import {
  about,
  contact,
  accessLogos,
  auditSiteSharing,
  trainingCourses,
  companyCreate,
} from "../../../../components/Paths/paths";
import styles from "./Header.module.scss";
import Icon, { IconType } from "../../../../components/Icon";
import useMegatron from "../../../../hooks/useMegatron";
import { useLocation } from "react-router-dom";

const headerItems = [
  { link: about, text: "About" },
  { link: trainingCourses, text: "Training Courses" },
  { link: auditSiteSharing, text: "Data Services" },
  { link: accessLogos, text: "Access & Logos" },
  { link: contact, text: "Contact" },
];

const headerItemsMegatron = [
  { link: about, text: "About the Directory"}
]


const PublicHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const {isMegatronFeaturedOn} = useMegatron();
  const {pathname} = useLocation();

 const isCreatePage = pathname === '/create';
  return (
    <nav className={styles.header}>
      <Link to="/" className={styles.logo}>
        <img src={logo} alt="BRCGS Directory Logo" />
      </Link>
      <ul className={clsx(styles.menuItems, { [styles.open]: menuOpen })}>
        {isMegatronFeaturedOn
          ? headerItemsMegatron.map((item) => (
              <li>
                <a rel="noreferrer" target="_blank" href={item.link}>
                  {item.text}
                </a>
              </li>
            ))
          : headerItems.map((item) => (
              <li>
                <a rel="noreferrer" target="_blank" href={item.link}>
                  {item.text}
                </a>
              </li>
            ))}
        <li>
          {!isCreatePage && <Link
            to={companyCreate}
            className={isMegatronFeaturedOn ? styles.loginMegatron : ""}
          >
            {" "}
            Create a free account
          </Link>}
          <Link
            to={"/private"}
            className={isMegatronFeaturedOn ? styles.loginMegatron : ""}
          >
            {" "}
            {isMegatronFeaturedOn ? "Log in to Directory" : "Login"}
          </Link>
        </li>
      </ul>
      <IconButton
        className={styles.toggleMenu}
        onClick={() => setMenuOpen((prev) => !prev)}
      >
        <Icon type={IconType.MENU} />
      </IconButton>
    </nav>
  );
};

export default PublicHeader;
